export const SET_LANDING_SEARCH_STRING = 'SET_LANDING_SEARCH_STRING';
export const CLEAR_LANDING_SEARCH_STRING = 'CLEAR_LANDING_SEARCH_STRING';
export const GET_APP_CONFIG_REQUEST = 'GET_APP_CONFIG_REQUEST';
export const GET_APP_CONFIG_SUCCESS = 'GET_APP_CONFIG_SUCCESS';
export const GET_APP_CONFIG_FAILURE = 'GET_APP_CONFIG_FAILURE';

export const GET_ETH_VS_USD_CONVERTER_REQUEST = 'GET_ETH_VS_USD_CONVERTER_REQUEST';
export const GET_ETH_VS_USD_CONVERTER_SUCCESS = 'GET_ETH_VS_USD_CONVERTER_SUCCESS';
export const GET_ETH_VS_USD_CONVERTER_FAILURE = 'GET_ETH_VS_USD_CONVERTER_FAILURE';
